module.exports = __webpack_public_path__ + "img/sc3.4e8cfb06.png";